import { render, staticRenderFns } from "./ModelTable.vue?vue&type=template&id=2a342782&scoped=true&"
import script from "./ModelTable.vue?vue&type=script&lang=ts&"
export * from "./ModelTable.vue?vue&type=script&lang=ts&"
import style0 from "./ModelTable.vue?vue&type=style&index=0&id=2a342782&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a342782",
  null
  
)

export default component.exports